// extracted by mini-css-extract-plugin
module.exports = {"className":"PageOverlay_className__MQ19L","visible":"PageOverlay_visible__0B1KT","inner":"PageOverlay_inner__Yld44"};